<template>
    <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
        <heading-view :right-column="show_table_view"></heading-view>

        <department-add-view v-if="show_add_view"></department-add-view>
        <department-table-view v-if="show_table_view"></department-table-view>
    </v-container>
</template>

<script>
    import {serverBus} from "../../main";

    import DepartmentAddView from "./DepartmentAddView";
    import DepartmentTableView from './DepartmentTableView'
    import HeadingView from '../heading/HeadingView'

    export default {

        components: {
            DepartmentAddView,
            DepartmentTableView,
            HeadingView,
        },

        created: function () {
            let table = 'odjeljenje';
            this.$store.commit('setTable', table);

            this.show_add_view = this.$route.matched[0].name === 'DepartmentAddView';
            this.show_table_view = this.$route.matched[0].name === 'DepartmentTableView';

            serverBus.$on('show-department-add-form', (item) => {
                if (this.$useDialog()===false) {
                   /*  serverBus.$emit('show-add-edit-dialog', table, item);
                } else { */
                    this.$navigate('/admin/odjeljenje/dodaj' + (item.id > 0 ? '/' + item.id : ''));
                }
            });

            serverBus.$on('show-department-profile', (item) => {
                this.$navigate('/admin/' + table + '/pregled/' + item.id);
            });
        },

        computed: {
            currentSchool() {
                return this.$store.getters.getSchool;
            }
        },

        watch: {
            currentSchool: {
                handler() {
                    this.$store.dispatch("setSchoolFieldId", null)
                    this.$router.push("/admin/odjeljenje")
                },
                deep: true
            }
        },

        methods: {
            showAddForm: function () {
                serverBus.$emit('show-department-add-form', {id: -1});
            },
        },

        beforeDestroy() {
            serverBus.$off('show-department-add-form');
            serverBus.$off('show-department-profile');
        },

        data: function () {
            return {
                show_add_view: false,
                show_table_view: false
            };
        }
    }
</script>